export const EXTENSION_PNG = '.png'
export const EXTENSION_GIF = '.gif'
export const EXTENSION_JPG = '.jpg'
export const EXTENSION_JPEG = '.jpeg'
export const EXTENSION_SVG = '.svg'
export const EXTENSION_PDF = '.pdf'
export const EXTENSION_DOC = '.doc'
export const EXTENSION_DOCX = '.docx'
export const EXTENSION_PPT = '.ppt'
export const EXTENSION_PPTX = '.pptx'
export const EXTENSION_XLS = '.xls'
export const EXTENSION_XLSX = '.xlsx'
export const EXTENSION_ALL_IMAGES = 'image/*'
export const EXTENSION_AVI = '.avi'
export const EXTENSION_WMV = '.wmv'
export const EXTENSION_MP4 = '.mp4'

export const IMAGE_EXTENSIONS = [
  EXTENSION_PNG,
  EXTENSION_GIF,
  EXTENSION_JPG,
  EXTENSION_JPEG
]

export const EXTENSIONS = [
  EXTENSION_PNG,
  EXTENSION_GIF,
  EXTENSION_JPG,
  EXTENSION_JPEG,
  EXTENSION_SVG,
  EXTENSION_PDF,
  EXTENSION_DOC,
  EXTENSION_DOCX,
  EXTENSION_PPT,
  EXTENSION_PPTX,
  EXTENSION_XLS,
  EXTENSION_XLSX,
  EXTENSION_AVI,
  EXTENSION_WMV,
  EXTENSION_MP4,
  EXTENSION_ALL_IMAGES
]

export type BlobFileTypes = typeof EXTENSIONS[number]
